import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { applySubQueryPlaceholders } from '../utils/applySubQueryPlaceholders';

export class ValueQuery extends BaseQuery {
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const { value, subQueries, allSubQueryValuesRequired } = this.options;
		return applySubQueryPlaceholders({
			executionOptions,
			subQueries,
			allSubQueryValuesRequired,
			template: value,
		}) as any as T;
	}
}